export { default as Cir } from './Cir';



// WEBPACK FOOTER //
// ./src/features/cir/index.js